import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _Inbox } from "../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { Alert } from "../../../../theme/Component/Alert";
import { VisorAnyDocument } from "../../../../documents/VisorAnyDocument";
import { Modal } from "../../../../theme/Component/Modal";
import { FileService } from "../../../../../core/services/FileService";

interface Props {
    ID: number;
}


export const DocumentsImp = ({ ID }: Props) => {

    const { instance, lista, setLista, setBean, bean } = useDataBean(_Inbox);
    const fileService = new FileService();

    const [modal, setModal] = useState<any>({ name: 'Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-xl' });

    useEffect(() => {
        getDocuments()
    }, [ID])

    const getDocuments = () => {
        instance.getDocumentsByProcedureImp(ID).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(
            err => {
                console.log(err);
            }
        )
    }

    const vierDocument = (item: any) => {
        setBean(item);
        console.log(item)
        setModal({ ...modal, "view": true });
    }

    return (
        <div className="row">
            <div className="col-md-12">
                {lista.length === 0 ? (
                    <h4>No hay documentos anexos</h4>
                ) : (
                    lista.map((item: any, index: number) => {
                        const document = item.DataBeanProperties.Docuemnt ? JSON.parse(item.DataBeanProperties.Docuemnt) : null;
                        const rawText = item.DataBeanProperties.Media ? JSON.parse(item.DataBeanProperties.Media) : null;

                        return (
                            <div className="row mt-3" key={index}>
                                <div className="col-md-12">
                                    <h4>{document?.DocumentName}</h4>
                                </div>
                                <div className="col-md-12">
                                    {!rawText || rawText.length === 0 ? (
                                        <p>No hay documentos para mostrar</p>
                                    ) : (
                                        <div className="list-group">
                                            {rawText.map((item: any, index: number) => {
                                                return (
                                                    <button onClick={() => { vierDocument(item) }} key={index} type="button" className="list-group-item list-group-item-action" aria-current="true">
                                                        <i className="ri-article-line fs-2 align-middle me-2 cursor"></i>
                                                        {item.UploadName} - {item.Name}
                                                    </button>
                                                )
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            <VisorAnyDocument url={fileService.getUrlFile(bean.MediaContext, bean.Media)} type={bean?.TypeName} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
}
